export default function MobileViewContainer({ children }) {
  return (
    <div style={{ backgroundColor: "white", width:"100vh", margin:"-16px -16px 10px"}}>
      <div style={{ margin: "20px" }}>{children}</div>
    </div>
  );
}
